<template>
  <div v-if="web_view == true" class="bg-white position-relative">
    <b-container class="position-relative h-100" :style="web_view_header_padding">
      <div
        class="d-flex justify-content-between"
        :style="[
          selected_report.logo_path !== null
            ? { marginBottom: '2.5rem' }
            : { marginBottom: '2.0rem' }
        ]"
      >
        <div class="flex-grow-1 pr-5">
          <template v-if="selected_report.logo_path !== null">
            <b-img
              :src="$store.state.static_host + selected_report.logo_path"
              class="report-logo-regular"
              :style="{ 'max-height': '40px' }"
            />
          </template>

          <template v-else>
            <h2 class="fw-600 mb-3">
              {{ lang !== 'ENG' ? selected_report.report_name : selected_report.report_name_e }}
            </h2>
          </template>
        </div>

        <div class="flex-grow-0">
          <b-button-group class="mr-3">
            <b-button
              v-if="active_gri_table"
              class="d-inline-flex f-140 py-1"
              :variant="show_gri_table ? 'dark-border-selected' : 'dark-border'"
              :disabled="show_gri_table"
              @click="$emit('showTableView', 'GRI')"
            >
              <div class="f-100 d-inline">GRI</div>
            </b-button>
            <b-button
              v-if="active_sasb_table"
              class="d-inline-flex f-140 py-1"
              :variant="show_sasb_table ? 'dark-border-selected' : 'dark-border'"
              :disabled="show_sasb_table"
              @click="$emit('showTableView', 'SASB')"
            >
              <div class="f-100 d-inline">SASB</div>
            </b-button>
            <b-button
              v-if="active_tcfd_table"
              class="d-inline-flex f-140 py-1"
              :variant="show_tcfd_table ? 'dark-border-selected' : 'dark-border'"
              :disabled="show_tcfd_table"
              @click="$emit('showTableView', 'TCFD')"
            >
              <div class="f-100 d-inline">TCFD</div>
            </b-button>
            <b-button
              v-if="active_dc_table"
              class="d-inline-flex f-140 py-1"
              :variant="show_dc_table ? 'dark-border-selected' : 'dark-border'"
              :disabled="show_dc_table"
              @click="$emit('showTableView', 'DATA_CENTER')"
            >
              <div class="f-100 d-inline">Data Center</div>
            </b-button>
          </b-button-group>

          <span
            v-if="show_printing_btn && !selected_report.sample_report"
            v-b-tooltip.hover
            :title="pdfReadyTooltip"
            class="d-inline-block"
          >
            <b-button
              :disabled="!pdfReady || isPrinting"
              variant="dark-border"
              class="d-inline-flex f-140 py-1 mr-1"
              :style="{ 'pointer-events': !pdfReady || isPrinting ? 'none' : 'auto' }"
              @click="handlePrintClick"
            >
              <b-spinner v-if="isPrinting" small />
              <div v-else class="f-100 d-inline">Print</div>
            </b-button>
          </span>
          <span
            v-if="show_translation_btn"
            v-b-tooltip.hover
            :title="translateBtnTooltip"
            class="d-inline-block"
          >
            <b-button
              :disabled="!pdfReady || isLangSwitching"
              variant="dark-border"
              class="d-inline-flex f-140 py-1 mr-1"
              :style="{
                'pointer-events': !pdfReady || isLangSwitching ? 'none' : 'auto'
              }"
              @click="toggleLang"
            >
              <b-spinner v-if="isLangSwitching" small />
              <div v-else class="f-100 d-inline">
                {{ lang !== 'ENG' ? 'ENG' : 'KOR' }}
              </div>
            </b-button>
          </span>
          <template v-if="!is_viewer">
            <b-button
              v-b-tooltip.hover
              variant="dark-border"
              size="lg"
              class="d-inline-flex f-110"
              :title="lang != 'ENG' ? '미리보기 닫기' : 'Close preview'"
              @click="$router.push({ name: 'CheckReport' })"
            >
              <fa icon="times" />
            </b-button>
          </template>
        </div>
      </div>

      <h2 v-if="selected_report.logo_path !== null" class="fw-600 mb-3">
        {{ lang !== 'ENG' ? selected_report.report_name : selected_report.report_name_e }}
      </h2>
      <div class="">{{ selected_report.start_date }} ~ {{ selected_report.end_date }}</div>

      <b-modal
        v-model="loadingModalVisible"
        centered
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        hide-footer
        size="sm"
        :title="loadingModalTitle"
      >
        <div class="py-2">
          <template v-if="isPrinting">
            <div class="mb-3">
              <div
                v-for="(step, i) in printStepLabels"
                :key="'print-' + i"
                class="d-flex align-items-center mb-2"
              >
                <b-icon
                  v-if="printCurrentStep > i + 1"
                  icon="check-circle-fill"
                  variant="success"
                  class="mr-2"
                />
                <b-spinner
                  v-else-if="printCurrentStep === i + 1"
                  small
                  variant="primary"
                  class="mr-2"
                />
                <b-icon v-else icon="circle" class="text-muted mr-2" />
                <span :class="{ 'text-muted': printCurrentStep < i + 1 }">{{ step }}</span>
              </div>
            </div>
            <b-progress
              :max="printTotalSteps"
              :value="printCurrentStep > printTotalSteps ? printTotalSteps : printCurrentStep"
              variant="primary"
              animated
              height="6px"
            />
          </template>
          <template v-else-if="isLangSwitching">
            <div class="mb-3">
              <div
                v-for="(step, i) in langSwitchStepLabels"
                :key="i"
                class="d-flex align-items-center mb-2"
              >
                <b-icon
                  v-if="langSwitchStep > i + 1"
                  icon="check-circle-fill"
                  variant="success"
                  class="mr-2"
                />
                <b-spinner
                  v-else-if="langSwitchStep === i + 1"
                  small
                  variant="primary"
                  class="mr-2"
                />
                <b-icon v-else icon="circle" class="text-muted mr-2" />
                <span :class="{ 'text-muted': langSwitchStep < i + 1 }">{{ step }}</span>
              </div>
            </div>
            <b-progress
              :max="3"
              :value="langSwitchStep > 3 ? 3 : langSwitchStep"
              variant="primary"
              animated
              height="6px"
              class="mb-2"
            />
            <p class="mb-0 text-center text-muted f-85">{{ langSwitchDirectionLabel }}</p>
          </template>
        </div>
      </b-modal>
    </b-container>
  </div>

  <div v-else>
    <div class="bg-white" style="height: 40vh">
      <b-container class="position-relative h-100 px-5">
        <div
          v-if="selected_report.logo_path !== null"
          class="position-absolute"
          style="padding-top: 50px"
        >
          <b-img
            :src="$store.state.static_host + selected_report.logo_path"
            class="report-logo-regular"
          />
        </div>
        <h2 class="mb-4 fw-600" style="padding-top: calc(40vh - 120px)">
          {{ lang !== 'ENG' ? selected_report.report_name : selected_report.report_name_e }}
        </h2>
        <div>{{ selected_report.start_date }} ~ {{ selected_report.end_date }}</div>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { updateParamsFromQueryString } from '@/components/util';
import PrintSb from '@/plugins/print_plugin/printareaSb.js';

export default {
  name: 'ViewerHeaderBasicSkChemical',
  components: {},
  props: {
    web_view: { type: Boolean, default: false },
    show_printing_btn: { type: Boolean, default: true },
    show_translation_btn: { type: Boolean, default: true },
    active_gri_table: {
      type: Boolean,
      default: false
    },
    active_sasb_table: {
      type: Boolean,
      default: false
    },
    active_tcfd_table: {
      type: Boolean,
      default: false
    },

    show_gri_table: {
      type: Boolean,
      default: false
    },
    show_sasb_table: {
      type: Boolean,
      default: false
    },
    show_tcfd_table: {
      type: Boolean,
      default: false
    },
    active_dc_table: {
      type: Boolean,
      default: false
    },
    show_dc_table: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show_data_table: {},
      show_business_case: {},
      low_height: false,
      isPrinting: false,
      printCurrentStep: 0,
      printTotalSteps: 3,
      loadingModalVisible: false,
      isLangSwitching: false,
      langSwitchStep: 0,
      langSwitchFromLang: ''
    };
  },
  computed: {
    ...mapGetters(['is_viewer']),
    ...mapState(['backend_host']),
    ...mapState('report_list', ['report_code', 'lang']),
    ...mapState('gri2021_report_view', ['report_structure']),
    ...mapGetters('gri2021_report_view', [
      'report_topic_specific_categories',
      'report_universal_categories',
      'report_topic_types'
    ]),
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('documents', ['document_list_loaded']),
    ...mapState('data_tables', ['table_list_loaded']),
    ...mapState('business_cases', ['business_case_loaded']),
    ...mapState('gri2021_report_view', ['report_contents_loaded']),
    ...mapState('assurance', ['assurance_list_loaded']),

    pdfReady() {
      return (
        this.document_list_loaded &&
        this.table_list_loaded &&
        this.business_case_loaded &&
        this.report_contents_loaded &&
        this.assurance_list_loaded
      );
    },
    printStepLabels() {
      if (this.lang !== 'ENG') {
        return ['콘텐츠 준비', '이미지 로딩', '인쇄 준비'];
      }
      return ['Preparing content', 'Loading images', 'Preparing print'];
    },
    langSwitchStepLabels() {
      if (this.langSwitchFromLang === 'ENG') {
        return ['Checking translation data', 'Converting content', 'Rendering'];
      }
      return ['번역 데이터 확인', '콘텐츠 변환', '화면 렌더링'];
    },
    langSwitchDirectionLabel() {
      return this.langSwitchFromLang === 'KOR' ? '한국어 → English' : 'English → 한국어';
    },
    loadingModalTitle() {
      if (this.isPrinting) {
        return this.lang !== 'ENG' ? 'PDF 출력 준비중' : 'Preparing PDF';
      }
      if (this.isLangSwitching) {
        return this.langSwitchFromLang !== 'ENG' ? '언어 전환중' : 'Switching Language';
      }
      return '';
    },
    translateBtnTooltip() {
      if (!this.pdfReady) {
        return this.lang !== 'ENG' ? '보고서 준비중입니다.' : 'Preparing report...';
      }
      return this.lang !== 'ENG' ? '영문보기' : 'Korean';
    },
    pdfReadyTooltip() {
      if (this.isPrinting) {
        return this.lang !== 'ENG' ? 'pdf 출력 준비중...' : 'Preparing PDF...';
      }
      if (this.pdfReady) {
        return this.lang !== 'ENG' ? '출력하기' : 'Print to PDF';
      }
      return this.lang !== 'ENG' ? 'pdf 출력을 준비중입니다.' : 'Preparing PDF...';
    },
    popTitle() {
      if (this.lang === 'KOR') {
        return this.selected_report.report_name;
      } else {
        return this.selected_report.report_name_e;
      }
    },
    main_color() {
      return this.selected_report.main_color;
    },
    web_view_header_padding() {
      return this.selected_report.logo_path !== null
        ? 'padding-top: 40px;padding-bottom: 40px;'
        : 'padding-top: 50px;padding-bottom: 50px;';
    }
  },
  methods: {
    ...mapMutations('report_list', ['change_lang']),
    async toggleLang() {
      if (this.isLangSwitching) return;
      this.isLangSwitching = true;
      this.langSwitchStep = 0;
      this.langSwitchFromLang = this.lang;
      this.loadingModalVisible = true;

      try {
        await this.$nextTick();
        await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));
        await this.delay(150);

        this.langSwitchStep = 1;
        await this.delay(500);

        this.langSwitchStep = 2;
        await this.delay(300);

        if (this.langSwitchFromLang === 'KOR') {
          this.change_lang('ENG');
          document.querySelector('title').textContent = this.selected_report.report_name_e;
          updateParamsFromQueryString('l', 'ENG', false);
        } else {
          this.change_lang('KOR');
          document.querySelector('title').textContent = this.selected_report.report_name;
          updateParamsFromQueryString('l', null, false);
        }

        this.langSwitchStep = 3;
        await this.$nextTick();
        await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));
        await this.delay(500);
      } finally {
        this.isLangSwitching = false;
        this.loadingModalVisible = false;
        this.langSwitchStep = 0;
      }
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async handlePrintClick() {
      if (!this.pdfReady || this.isPrinting) return;

      this.isPrinting = true;
      this.printCurrentStep = 0;
      this.loadingModalVisible = true;

      try {
        await this.$nextTick();
        await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));
        await this.delay(150);

        this.printCurrentStep = 1;
        await this.$nextTick();
        await this.delay(600);

        this.printCurrentStep = 2;
        await this.waitForImages();
        await this.delay(600);

        this.printCurrentStep = 3;
        await this.delay(400);

        this.loadingModalVisible = false;

        new PrintSb({
          ids: '#full-report-preview',
          popTitle: this.popTitle,
          endCallback: () => {
            this.isPrinting = false;
            this.printCurrentStep = 0;
          }
        });
      } finally {
        this.isPrinting = false;
        this.printCurrentStep = 0;
        this.loadingModalVisible = false;
      }
    },
    waitForImages() {
      return new Promise(resolve => {
        const printElement = document.querySelector('#full-report-preview');
        if (!printElement) {
          resolve();
          return;
        }
        const images = Array.from(printElement.querySelectorAll('img'));
        const allLoaded = images.length === 0 || images.every(img => img.complete);
        if (allLoaded) {
          resolve();
          return;
        }
        let loaded = 0;
        const total = images.filter(img => !img.complete).length;
        const onLoad = () => {
          loaded++;
          if (loaded >= total) resolve();
        };
        images.forEach(img => {
          if (!img.complete) {
            img.addEventListener('load', onLoad, { once: true });
            img.addEventListener('error', onLoad, { once: true });
          }
        });
        setTimeout(resolve, 10000);
      });
    }
  }
};
</script>
